import "./intro.scss";
import Typical from "react-typical"

export default function Intro() {
  return (
    <div className="intro" id="intro">
      <div className="left">
        <div className="imgContainer">
          <img src="assets/boat.jpg" alt="" />
          <div className="center">
            <div className="stage-cube-cont">
              <div className="cubespinner">
                  <div className="face1">
                    <img src="assets/face1.svg" alt="" /> 
                  </div>
                  <div className="face2">
                    <img src="assets/face2.svg" alt="" />
                  </div>
                  <div className="face3">
                    <img src="assets/face3.svg" alt="" />
                  </div>
                  <div className="face4">
                    <img src="assets/face4.svg" alt="" />
                  </div>
                  <div className="face5">
                    <img src="assets/face5.svg" alt="" />
                  </div>
                  <div className="face6">
                    <img src="assets/face6.svg" alt="" />
                  </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="right">
        <div className="wrapper">
          <h2>Hi There, I'm</h2>
          <h1>Ronald Guerra</h1>
          <h3>
            Software {" "}
            <Typical
              loop = {Infinity}
              wrapper = "b"
              steps = {[
                  3000,
                  "Developer 🖥️", 
                  3000,
                  "Engineer 🔩",
                  3000, 
                  "Enthusiast ❤️", 
                  3000,
                  "God 😄"
              ]}
            />
          </h3>
        </div>
        <a href="#portfolio">
          <img src="assets/arrow-down.png" alt="" />
        </a>
      </div>
    </div>
  );

}
